import { isE164 } from '@lib/contacts/utils/phone';
import { validEmail } from '@lib/shared/utils/valid-email-schema';
import * as z from 'zod';

export const signupWithPhoneSchema = z
  .object({
    email: validEmail('Please enter a valid email address'),
    firstName: z.string().min(2, 'First name must be at least 2 characters'),
    lastName: z.string().min(2, 'Last name must be at least 2 characters'),
    password: z.string().min(8, 'Password must be at least 8 characters'),
    phone: z.string().optional(),
    smsOptIn: z.boolean(),
    agreeToTerms: z.boolean().refine(val => val === true, {
      message: 'You must agree to the Privacy Policy and Terms and Conditions',
    }),
  })
  .refine(values => !values.smsOptIn || !!values.phone?.trim(), {
    message: 'Add a phone number to receive text notifications',
    path: ['phone'],
  })
  .refine(values => !values.phone?.trim() || isE164(values.phone), {
    message: 'Please enter a valid phone number',
    path: ['phone'],
  });

export type SignupWithPhoneValues = z.infer<typeof signupWithPhoneSchema>;
